(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-motion-atelier"] && !Shopify.designMode) return;
  try {
    
const initHwMotionAtelier = () => {
  const root = document.querySelector('.hw-storefront[data-hw-home]');
  const marquee = document.querySelector('[data-hw-motion-marquee]');
  if (!root || !marquee || root.dataset.hwMotionAtelierReady === '1') return;

  root.dataset.hwMotionAtelierReady = '1';
  root.dataset.hwMotion = 'atelier';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canObserve = 'IntersectionObserver' in window;

  const visibleNow = (element) => {
    const box = element.getBoundingClientRect();
    return box.bottom > 0 && box.top < (window.innerHeight || document.documentElement.clientHeight);
  };

  const revealObserver = canObserve && !reducedMotion ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        entry.target.classList.remove('hw-motion-visible');
        return;
      }
      if (entry.intersectionRatio >= 0.08) {
        entry.target.classList.add('hw-motion-visible');
      }
    });
  }, { threshold: [0, 0.08], rootMargin: '0px' }) : null;

  const applyReveal = (element, index) => {
    if (!element || element.dataset.hwMotionRevealReady === '1') return;
    element.dataset.hwMotionRevealReady = '1';
    element.classList.add('hw-motion-reveal');
    element.style.setProperty('--hw-motion-delay', String(Math.min((index % 5) * 70, 280)) + 'ms');

    if (element.matches('.hw-card,.hw-live-brand-item')) {
      element.style.setProperty('--hw-motion-x', (index % 2 === 0 ? '-18px' : '18px'));
      element.style.setProperty('--hw-motion-enter-y', '18px');
    }

    if (reducedMotion || !revealObserver) {
      element.classList.add('hw-motion-visible');
    } else {
      revealObserver.observe(element);
      if (visibleNow(element)) requestAnimationFrame(() => element.classList.add('hw-motion-visible'));
    }
  };

  const prepareWriting = (element, delay) => {
    if (!element || element.dataset.hwMotionWriteReady === '1') return;
    const text = element.textContent.trim();
    if (!text || element.children.length) return;

    element.dataset.hwMotionWriteReady = '1';
    element.classList.add('hw-motion-write');
    element.style.setProperty('--hw-write-delay', String(delay || 0) + 'ms');
    element.setAttribute('aria-label', text);

    const fragment = document.createDocumentFragment();
    text.split(/\s+/).forEach((word, index, words) => {
      const span = document.createElement('span');
      span.className = 'hw-motion-word';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--hw-word-index', String(index));
      span.textContent = word;
      fragment.appendChild(span);
      if (index < words.length - 1) fragment.appendChild(document.createTextNode(' '));
    });
    element.replaceChildren(fragment);

    if (reducedMotion || !revealObserver) {
      element.classList.add('hw-motion-visible');
    } else {
      revealObserver.observe(element);
      if (visibleNow(element)) requestAnimationFrame(() => element.classList.add('hw-motion-visible'));
    }
  };

  const initialRevealTargets = [
    ...root.querySelectorAll('.hw-hero-copy > *, .hw-brand-ribbon, .hw-arrivals, .hw-section-heading, .hw-card, .hw-style-card, .hw-promise-inner > div, .hw-newsletter > div, .hw-live-brand-item')
  ];
  initialRevealTargets.forEach(applyReveal);

  const writingTargets = [
    ...root.querySelectorAll('.hw-hero-copy h1, .hw-section-heading h2, .hw-promise h2, .hw-newsletter h2')
  ];
  writingTargets.forEach((element, index) => prepareWriting(element, Math.min(index * 45, 180)));

  const footer = document.querySelector('.hs-footer');
  if (footer) {
    [...footer.querySelectorAll('.hs-footer__brand, .hs-footer__columns, .hs-footer__follow-bottom, .hs-footer__bottom')].forEach((element, index) => applyReveal(element, index));
    const logo = footer.querySelector('.hs-footer__brand-logo');
    if (logo) {
      logo.classList.add('hw-motion-footer-logo');
      if (reducedMotion || !revealObserver) {
        logo.classList.add('hw-motion-visible');
      } else {
        revealObserver.observe(logo);
        if (visibleNow(logo)) requestAnimationFrame(() => logo.classList.add('hw-motion-visible'));
      }
    }
  }

  const mediaTargets = [
    ...root.querySelectorAll('.hw-hero-media, .hw-style-card, .hw-live-brand-media')
  ];
  mediaTargets.forEach((element) => element.classList.add('hw-motion-media-reveal'));

  if (reducedMotion || !canObserve) {
    mediaTargets.forEach((element) => element.classList.add('hw-motion-visible'));
  } else {
    const activeMedia = new Set();
    const mediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('hw-motion-visible', entry.isIntersecting);
        if (entry.isIntersecting) activeMedia.add(entry.target);
        else activeMedia.delete(entry.target);
      });
    }, { rootMargin: '20% 0px 20% 0px' });

    mediaTargets.forEach((element) => mediaObserver.observe(element));

    let ticking = false;
    const updateParallax = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      activeMedia.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
        const shift = (progress - 0.5) * (element.classList.contains('hw-hero-media') ? 38 : 26);
        element.style.setProperty('--hw-motion-y', shift.toFixed(2) + 'px');
      });
      ticking = false;
    };

    const requestParallax = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    const canParallax = window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)').matches;
    if (canParallax) {
      const pageWrapper = document.querySelector('.page-wrapper');
      window.addEventListener('scroll', requestParallax, { passive: true });
      pageWrapper?.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax, { passive: true });
      requestParallax();
    }
  }

  const dynamicObserver = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        const cards = node.matches('.hw-card,.hw-live-brand-item') ? [node] : [...node.querySelectorAll('.hw-card,.hw-live-brand-item')];
        cards.forEach((card, index) => applyReveal(card, index));

        const headings = node.matches('.hw-section-heading h2') ? [node] : [...node.querySelectorAll('.hw-section-heading h2')];
        headings.forEach((heading, index) => prepareWriting(heading, index * 35));
      });
    });
  });
  dynamicObserver.observe(root, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHwMotionAtelier, { once: true });
} else {
  initHwMotionAtelier();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-watch-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.querySelector('[data-hw-watch-stories]');
  if (!section || section.dataset.hwStoriesReady === '1') return;
  section.dataset.hwStoriesReady = '1';

  const storefront = document.querySelector('.hw-storefront[data-hw-home]');
  const arrivals = storefront?.querySelector('[data-hw-arrivals]');
  const ribbon = storefront?.querySelector('.hw-brand-ribbon');

  if (storefront) {
    if (arrivals) storefront.insertBefore(section, arrivals);
    else if (ribbon?.nextSibling) storefront.insertBefore(section, ribbon.nextSibling);
    else storefront.appendChild(section);
  }

  const rail = section.querySelector('[data-hw-story-rail]');
  const templates = [...section.querySelectorAll('template[data-hw-story-template]')];
  if (!rail || !templates.length) return;

  const pool = templates.map((template) => ({
    id: template.dataset.storyId,
    template
  })).filter((item) => item.id);

  const visibleCount = Math.min(4, pool.length);
  const storageKey = 'hw-watch-stories-selection-v8';

  const shuffle = (items) => {
    const copy = [...items];
    for (let index = copy.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [copy[index], copy[swapIndex]] = [copy[swapIndex], copy[index]];
    }
    return copy;
  };

  let chosenIds = [];
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (
      Array.isArray(stored) &&
      stored.length === visibleCount &&
      stored.every((id) => pool.some((item) => item.id === id))
    ) {
      chosenIds = stored;
    }
  } catch (error) {}

  if (!chosenIds.length) {
    chosenIds = shuffle(pool.map((item) => item.id)).slice(0, visibleCount);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(chosenIds));
    } catch (error) {}
  }

  chosenIds.forEach((id, index) => {
    const item = pool.find((candidate) => candidate.id === id);
    if (!item) return;

    const fragment = item.template.content.cloneNode(true);
    const video = fragment.querySelector('video');

    if (video) {
      video.removeAttribute('autoplay');
      video.setAttribute('preload', 'none');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const directSrc = video.getAttribute('src');
      if (directSrc) {
        video.dataset.src = directSrc;
        video.removeAttribute('src');
      }

      video.querySelectorAll('source[src]').forEach((source) => {
        source.dataset.src = source.getAttribute('src');
        source.removeAttribute('src');
      });
    }

    rail.appendChild(fragment);
  });

  const videos = [...rail.querySelectorAll('video')];

  const loadVideo = (video) => {
    if (video.dataset.hwLoaded === '1') return;

    let hasSource = false;

    if (video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
      hasSource = true;
    }

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      hasSource = true;
    });

    if (!hasSource) return;

    video.dataset.hwLoaded = '1';
    video.load();
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => {
      loadVideo(video);
      video.play().catch(() => {});
    });
    return;
  }

  const loadObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadVideo(entry.target);
      loadObserver.unobserve(entry.target);
    });
  }, { rootMargin:'45% 0px 45% 0px', threshold:0 });

  const playObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= .35) {
        loadVideo(video);
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold:[0,.35,.7] });

  videos.forEach((video) => {
    loadObserver.observe(video);
    playObserver.observe(video);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach((video) => video.pause());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const initHwCollectionMotion = () => {
    const main = document.querySelector('#MainContent[data-template^="collection"]');
    if (!main || main.dataset.hwCollectionMotionReady === '1') return;
    main.dataset.hwCollectionMotionReady = '1';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canObserve = 'IntersectionObserver' in window;
    const visibleNow = (element) => {
      const box = element.getBoundingClientRect();
      return box.bottom > 0 && box.top < (window.innerHeight || document.documentElement.clientHeight);
    };

    const observer = canObserve && !reducedMotion ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          entry.target.classList.remove('hw-motion-visible');
          return;
        }
        if (entry.intersectionRatio >= 0.08) {
          entry.target.classList.add('hw-motion-visible');
        }
      });
    }, { threshold: [0, 0.08], rootMargin: '0px' }) : null;

    const showOrObserve = (element) => {
      if (reducedMotion || !observer) {
        element.classList.add('hw-motion-visible');
        return;
      }
      observer.observe(element);
      if (visibleNow(element)) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => element.classList.add('hw-motion-visible'));
        });
      }
    };

    const prepareWriting = (element, delay = 0) => {
      if (!element || element.dataset.hwCollectionWriteReady === '1') return;
      const text = element.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      element.dataset.hwCollectionWriteReady = '1';
      element.classList.add('hw-motion-write');
      element.style.setProperty('--hw-write-delay', String(delay) + 'ms');
      element.setAttribute('aria-label', text);

      if (!element.querySelector('.hw-motion-word')) {
        const fragment = document.createDocumentFragment();
        text.split(/\s+/).forEach((word, index, words) => {
          const span = document.createElement('span');
          span.className = 'hw-motion-word';
          span.setAttribute('aria-hidden', 'true');
          span.style.setProperty('--hw-word-index', String(index));
          span.textContent = word;
          fragment.appendChild(span);
          if (index < words.length - 1) fragment.appendChild(document.createTextNode(' '));
        });
        element.replaceChildren(fragment);
      }

      showOrObserve(element);
    };

    const prepareCard = (card, index = 0) => {
      if (!card || card.dataset.hwCollectionRevealReady === '1') return;
      card.dataset.hwCollectionRevealReady = '1';
      card.classList.add('hw-motion-reveal');
      card.style.setProperty('--hw-motion-delay', String(Math.min((index % 5) * 70, 280)) + 'ms');
      card.style.setProperty('--hw-motion-x', index % 2 === 0 ? '-18px' : '18px');
      card.style.setProperty('--hw-motion-enter-y', '18px');
      showOrObserve(card);
    };

    const prepareReveal = (element, index = 0) => {
      if (!element || element.dataset.hwCollectionRevealReady === '1') return;
      element.dataset.hwCollectionRevealReady = '1';
      element.classList.add('hw-motion-reveal');
      element.style.setProperty('--hw-motion-delay', String(Math.min((index % 5) * 70, 280)) + 'ms');
      showOrObserve(element);
    };

    const process = (root = main) => {
      const title = main.querySelector('h1');
      const headingSection = title?.closest('.shopify-section');
      if (headingSection) {
        [...headingSection.querySelectorAll('p')].slice(0, 3).forEach((element, index) => prepareReveal(element, index));
      }

      const controls = main.querySelectorAll('.facets-toggle,.facets-block-wrapper');
      controls.forEach((element, index) => prepareReveal(element, index));

      const cards = root.matches?.('.product-grid__item') ? [root] : [...(root.querySelectorAll?.('.product-grid__item') || [])];
      cards.forEach((card) => {
        const grid = card.parentElement;
        const index = grid ? [...grid.children].indexOf(card) : 0;
        prepareCard(card, Math.max(index, 0));
      });
    };

    process(main);

    const results = main.querySelector('results-list') || main;
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          process(node);
        });
      });
    }).observe(results, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element && main.contains(event.target)) process(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHwCollectionMotion, { once: true });
  } else {
    initHwCollectionMotion();
  }


  } catch(e) { console.error(e); }
})();
})();
